const navLinks = {
  ROOT: '/batchprocess',
  BATCH_TIME_RECOGNITIONS: '/batchprocess/timerecognitions',
  BATCH_TIME_RECORDS: '/batchprocess/timerecords'
};

export default navLinks;